<template>
  <span @click="$emit('click')">
    <Icon
      v-if="additionalIconName && additionalIconPos === 'left'"
      v-bind="{ ...additionalIconProps, name: additionalIconName }"
    />
    {{ label }}
    <Icon
      v-if="additionalIconName && additionalIconPos === 'right'"
      v-bind="{ ...additionalIconProps, name: additionalIconName }"
    />
  </span>
</template>

<script>
import Icon from '@/objects/Icon';
import { IconNameTypes } from '@/constants/enums';
export default {
  name: 'ButtonLabel',
  props: {
    label: String,
    additionalIconProps: {
      color: {
        type: String,
        validator: (val) => ['neutral0', 'primaryBlueLight'].includes(val),
      },
      class: {
        type: String,
      },
      size: {
        type: String,
        validator: (val) => ['m', 'l'].includes(val),
      },
    },
    additionalIconName: {
      type: String,
      validator: (val) => IconNameTypes.includes(val),
    },
    additionalIconPos: {
      type: String,
      default: 'right',
      validator: (val) => ['left', 'right'].includes(val),
    },
  },
  components: {
    Icon,
  },
  data() {
    return {};
  },
};
</script>
